import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { ScheduleAction } from '@cbridge-packages/schedule';
import { ScheduleIntervalAction } from '../scheduleInterval.action';

export const onRemoveScheduleEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(ScheduleAction.remove.done),
  mergeMap((payload) => {
    const { params: { scheduleId } } = payload;

    return [
      ScheduleIntervalAction.removeSchedule({ scheduleId }),
    ];
  }),
);
